import Lottie from "lottie-react";
import { motion } from "framer-motion";
import { FaGithub } from "react-icons/fa";
import { AiOutlineLinkedin } from "react-icons/ai";
import Skills from "../Skills/Skills";
import Experience from "../Experience/Experience";
import About from "../About/About";
import Projects from "../Projects/Projects";
import Education from "../Education/Education";
import Titlerole from "../TitleText/Titlerole";
import devAnimation from "../../assets/programmer.json";

const sectionReveal = {
  initial: { opacity: 0, y: 36 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

function Homepage() {

  return (
    <>
      <div
  id="Home"
  className="relative flex items-center bg-no-repeat min-h-[85vh] md:min-h-[90vh] scroll-mt-24"
>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-5
                  w-full max-w-screen-xl px-4 sm:px-8 mx-auto">

    {/* Intro */}
    <motion.div
      className="flex flex-col justify-center
                    items-center md:items-start
                    m-8 md:m-28"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <h1 className="text-4xl md:text-5xl mb-4 text-slate-100 tracking-tight">
        Hi, I'm
        <br />
        <span className="font-semibold bg-gradient-to-r from-white via-sky-100 to-indigo-200 bg-clip-text text-transparent">
          Nidhi Shetty
        </span>
      </h1>

      <h3 className="text-2xl sm:text-4xl font-bold min-h-[2.75rem] sm:min-h-[3.25rem]">
        <Titlerole />
      </h3>

      <p className="text-lg mt-4 text-slate-300 font-light max-w-md leading-relaxed">
        Passionate about building scalable web applications and bringing
        ideas to life through clean code.
      </p>
    </motion.div>

    {/*Anime */}
    <motion.div
      className="hidden md:flex items-center justify-center"
      initial={{ opacity: 0, scale: 0.94 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
    >
      <Lottie animationData={devAnimation} loop={true} className="w-[400px] h-[400px]" />
    </motion.div>

  </div>
</div>
    
      <About />

      <section id="skills" className="py-12 scroll-mt-24">
        <motion.div className="container mx-auto px-4" {...sectionReveal}>
          <h2 className="text-3xl md:text-4xl text-center mb-2">
            <span className="section-heading text-3xl md:text-4xl">SKILLS</span>
          </h2>
          <Skills />
        </motion.div>
      </section>

      <section id="experience" className="py-12 scroll-mt-24">
        <motion.div className="container mx-auto px-4" {...sectionReveal}>
          <h2 className="text-3xl md:text-4xl text-center mb-4">
            <span className="section-heading text-3xl md:text-4xl">EXPERIENCE</span>
          </h2>
          <p className="text-lg text-center mb-8 text-slate-300/95 font-light max-w-3xl mx-auto leading-relaxed">
            From enterprise integration and dashboards at Reliance Jio to AI-driven
            products and rich media UI at Vosyn Technologies, I’ve shipped scalable
            web experiences across Angular, React, TypeScript, and Java ecosystems.
          </p>
          <Experience />
        </motion.div>
      </section>

      <section id="projects" className="py-10 scroll-mt-24">
        <motion.div className="container mx-auto px-4" {...sectionReveal}>
          <h2 className="text-3xl md:text-4xl text-center mb-6">
            <span className="section-heading text-3xl md:text-4xl">FEATURED PROJECTS</span>
          </h2>
          <Projects />
        </motion.div>
      </section>

      

      <section id="education" className="py-12 scroll-mt-24">
        <motion.div {...sectionReveal}>
          <Education />
        </motion.div>
      </section>

      <footer className="relative bg-surface-deep/95 border-t border-violet-400/15 text-slate-200 py-10 mt-12 overflow-hidden">
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-sky-400/40 to-transparent"
          aria-hidden
        />
        <div className="container mx-auto px-4 text-center relative">
          <p className="mb-5 text-slate-400 text-sm md:text-base">
            © {new Date().getFullYear()} Nidhi Shetty · Built with React and Tailwind
          </p>
          <div className="flex justify-center items-center gap-10">
            <a
              href="https://github.com/Code2voyager"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-300 hover:text-sky-300 transition-all duration-300 hover:scale-110"
              aria-label="GitHub"
            >
              <FaGithub size={36} />
            </a>
            <a
              href="https://www.linkedin.com/in/nidhis224/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-300 hover:text-sky-300 transition-all duration-300 hover:scale-110"
              aria-label="LinkedIn"
            >
              <AiOutlineLinkedin size={38} />
            </a>
          </div>
        </div>




        
      </footer>
    </>
  );
}

export default Homepage;
